import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertPngToTiff() {
  return <ImageConverterTemplate sourceFormat="PNG" targetFormat="TIFF" acceptTypes=".png,image/png" slug="convert-png-to-tiff" gradientColors="from-purple-500 to-pink-600" accentColor="purple" />;
}
